export const $format = new Intl.NumberFormat('en-US', {
    style: 'currency', currency: 'USD'
});

export const format = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
});